const reloadKey = 'vite-preload-reload';
const attemptedReloads = new Set<string>();

function getReloadKey(event: Event): string {
    const payload = (event as Event & { payload?: unknown }).payload;
    const message = payload instanceof Error ? payload.message : String(payload ?? 'unknown');

    return `${reloadKey}:${message}`;
}

function hasAttemptedReload(storage: Storage | null, key: string): boolean {
    if (storage === null) {
        return attemptedReloads.has(key);
    }

    try {
        return storage.getItem(key) !== null;
    } catch {
        return attemptedReloads.has(key);
    }
}

function rememberReloadAttempt(storage: Storage | null, key: string): void {
    attemptedReloads.add(key);

    if (storage === null) {
        return;
    }

    try {
        storage.setItem(key, '1');
    } catch {
    }
}

// Shared once-per-key reload guard, keyed off sessionStorage (falling back to an
// in-memory Set) so a distinct failure gets one recovery attempt without looping
// forever if the reload doesn't fix it. Returns whether it actually reloaded.
export function reloadOnce(key: string, storage: Storage | null, reload: () => void): boolean {
    if (hasAttemptedReload(storage, key)) {
        return false;
    }

    rememberReloadAttempt(storage, key);
    reload();

    return true;
}

export function handleVitePreloadError(
    event: Event,
    storage: Storage | null,
    reload: () => void,
): void {
    const key = getReloadKey(event);

    if (!reloadOnce(key, storage, reload)) {
        return;
    }

    event.preventDefault();
}

export function registerVitePreloadErrorRecovery(): void {
    window.addEventListener('vite:preloadError', (event) => {
        let storage: Storage | null = null;

        try {
            storage = window.sessionStorage;
        } catch {
        }

        handleVitePreloadError(event, storage, () => window.location.reload());
    });
}
